import { createEntityAdapter, createSlice, isAsyncThunkAction, isRejected, PayloadAction } from '@reduxjs/toolkit';

import type { IHistoryGame } from '../../../api/fetchers/history/types';
import { fetchOlderHistoryAction, fetchTodayHistoryAction } from '../../apiActions/fetchHistoryAction';

import type { HistoryState } from './types';

const historyAdapter = createEntityAdapter<IHistoryGame>({
  selectId: (historyDay: IHistoryGame) => historyDay.gameId,
  sortComparer: (a: IHistoryGame, b: IHistoryGame) => b.dataTimeStart.localeCompare(a.dataTimeStart),
});

export const historySlice = createSlice({
  name: 'history',
  initialState: historyAdapter.getInitialState({
    loading: true,
    loadMore: true,
    page: 0,
    gameInfo: null,
  } as HistoryState),
  reducers: {
    setGameInfo: (state, action: PayloadAction<HistoryState['gameInfo']>) => {
      state.gameInfo = action.payload;
    },
    setLoadingDetails: (state, action: PayloadAction<HistoryState['loadingDetails']>) => {
      state.loadingDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodayHistoryAction.fulfilled, (state, action) => {
        historyAdapter.upsertMany(state, action.payload);
      })
      .addCase(fetchOlderHistoryAction.fulfilled, (state, action) => {
        historyAdapter.upsertMany(state, action.payload);
        state.page = action.meta.arg.rowEnd / 20;
        state.loadMore = action.payload.length > 0;
      })
      .addMatcher(isAsyncThunkAction(fetchTodayHistoryAction, fetchOlderHistoryAction), (state, action) => {
        state.loading = action.meta.requestStatus === 'pending';
        state.error = void 0;
      })
      .addMatcher(isRejected(fetchTodayHistoryAction, fetchOlderHistoryAction), (state, action) => {
        state.error = action.error;
      });
  },
});

export const historyActions = historySlice.actions;
